import React from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import './Simulation.css';
import Node from './Node';
import nodeItems from 'data/simulation-nodes.json';
import CssTitle from 'Components/CssTitle';
import CssBox from 'Components/CssBox';

const Builder = () => {
  const roles = useSelector((state) => state?.userReducer?.roles);
  const canModify =
    !roles?.includes("Super Admin") && !roles?.includes("User_ReadOnly");

  if (!canModify) {
    return null;
  }

  return (
    <CssBox className='SimulationBuilder' >
      <div className='simulation-builder-wrapper'>
        <CssTitle variant='h6' className='node-list-title'>Situation Room Builder</CssTitle>
        <Grid container className='nodes' justifyContent='center'>
          {nodeItems.map((item, index) => <Node nodeData={item} key={index} />)}
        </Grid>
      </div>
    </CssBox>
  );
}

export default Builder;
